<div class="language">
	<div class="row d-flex flex-row">
		<div mat-dialog-title class="col-auto">
			{{'LANGUAGE.TITLE' | translate}}
		</div>
		<div class="col-auto ml-auto">
            <button mat-icon-button (click)="close()"  [attr.aria-label]="'ALT-TEXT.CLOSE-DIALOG'  | translate">
                <mat-icon aria-hidden>close</mat-icon>
            </button>
		</div>
	</div>
	<div mat-dialog-content class="row">
		<app-language></app-language>
	</div>
	<div mat-dialog-actions class="row">
		<div class="ml-auto col-auto"><button mat-button mat-dialog-close mat-raised-button color="primary" (click)="cancel()">{{'LANGUAGE.CLOSE' | translate}}</button></div>
	</div>
</div>
